// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-d8d36f44] {\n  width: 85%;\n  padding-top: 30px;\n  margin-left: 10%;\n  padding-bottom: 50px;\n}\n.ptext[data-v-d8d36f44] {\n  width: 95%;\n  line-height: 24px;\n}\n.imgSize[data-v-d8d36f44] {\n  width: 95%;\n}\n", ""]);
// Exports
module.exports = exports;
